import React, { useState } from "react";
import {
  removeTags,
  useNotify,
  useRecordContext,
} from "react-admin";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Typography
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import purify from "dompurify";

// Para evitar que o Datagrid utilize o evento...
export const MouseEventEater = ({ children }) => {
  const eat = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return <div onClick={eat}>{children}</div>;
};

const XRichTextField = ({ value, stripTags }) => {
  return (
    <Typography variant="body2" component="div" sx={{ height: "40vh" }}>
      {value == null ? (
        ""
      ) : stripTags ? (
        removeTags(value)
      ) : (
        <span
          dangerouslySetInnerHTML={{
            __html: purify.sanitize(value),
          }}
        />
      )}
    </Typography>
  );
};

export const TextMediaShow = ({ open, onClose, title, body, preview }) => {
  const notify = useNotify();

  // Desativa essa opção, ja que o texto agora está formatado em modo rico (HTML)
  // const copyToClipboard = async () => {
  //   try {
  //     await navigator.clipboard.writeText(
  //       "" + title + "\n\n" + removeTags(body)
  //     );
  //     notify("Copiado!", { type: "success" });
  //   } catch (err) {
  //     notify("Erro ao copiar", { type: "error" });
  //   }
  // };

  if (open) {
    return (
      <Dialog open={open}  maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: "14px" } }}>
        <DialogTitle>
          <Typography variant="caption">Título</Typography>
          <Typography>{title}</Typography>
        </DialogTitle>
        <DialogContent>
          {/* <TextField multiline fullWidth value={body} /> */}
          <Typography variant="caption">Corpo</Typography>
          <div
            style={{
              background: "#fefefe",
              border: "1px solid rgba(0,0,0,0.2)",
              padding: "5px",
              borderRadius: "5px",
              overflow: "auto"
            }}
          >
            <XRichTextField value={body} stripTags={preview} />
          </div>
        </DialogContent>
        <DialogActions>
          {preview && (
            <Typography color="error" textAlign={"center"}>
              Esta é uma leitura limitada do conteúdo total, por favor realizar
              o download.
            </Typography>
          )}
          {/* <Button onClick={copyToClipboard} color="success">
            Copiar
          </Button> */}
          <div style={{ flex: 1 }}></div>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose(e);
            }}
            color="primary"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  return null;
};

const ControlTextPreview = ({ data }) => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);

  if (!record || !record.body) {
    // Não renderiza o botão se não houver texto no campo "body"
    return null;
  }

  const handleOpen = (e) => {
    setOpen(true);
  };
  const handleClose = (e) => {
    setOpen(false);
  };

  if (record) {
    return (
      <MouseEventEater>
        {/* Botão para abrir o dialog */}
        <Tooltip title="Por favor realizar o download para a cópia completa do texto, esta é só uma pré-visualização com tamanho limitado">
          <Button
            variant="contained"
            size="small"
            onClick={handleOpen}
            startIcon={<VisibilityOutlinedIcon />}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              px: 1.25,
              color: "#0f172a",
              background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
              border: "1px solid rgba(15,23,42,0.12)",
              boxShadow: "0 2px 8px rgba(15, 23, 42, 0.08)",
              "&:hover": {
                background: "linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)",
                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.12)",
              },
            }}
          >
            Preview
          </Button>
        </Tooltip>
        <TextMediaShow
          open={open}
          onClose={handleClose}
          body={record.body}
          title={record.name}
          preview
        />
      </MouseEventEater>
    );
  }
  return null;
};

export { ControlTextPreview };
